export * from './push-notifications-configuration.model';
